import { useEffect, useState } from 'react'

import { config } from '@skytech/config'
import { NotificationBubble } from '@skytech/ui'
import { Link, useLocation } from 'react-router-dom'

import { useAppContext } from '@/App.context'
import { Translation } from '@/components/i18n/Translation'
import useBetaAccess from '@/hooks/beta-access'
import { useIsMobit, useProfile } from '@/hooks/user'
import { appRoutes } from '@/util/misc'
import { useNotifications } from '@/util/useNotifications'

import './sub-navigation.scss'

const DeviceOrdersLinkContent = () => {
  const { newDeviceOrderAmount } = useNotifications()

  return (
    <>
      <Translation id="Device Orders" />

      {newDeviceOrderAmount > 0 && <NotificationBubble isDealer amount={newDeviceOrderAmount} />}
    </>
  )
}

const SubscriptionOrdersLinkContent = () => {
  const { newSubscriptionOrderAmount } = useNotifications()

  return (
    <>
      <Translation id="Subscription Orders" />

      {newSubscriptionOrderAmount > 0 && (
        <NotificationBubble isDealer amount={newSubscriptionOrderAmount} />
      )}
    </>
  )
}

const ShopOrdersLinkContent = () => {
  const isMobit = useIsMobit()
  const { newShopOrderAmount } = useNotifications()

  return (
    <>
      <Translation id={isMobit ? 'Multicase Orders' : 'Shop Orders'} />

      {newShopOrderAmount > 0 && <NotificationBubble isDealer amount={newShopOrderAmount} />}
    </>
  )
}
// @ts-ignore
const useSubLinks = mainPath => {
  const { hasShop } = useBetaAccess()
  const isDevelopmentMode = config.ENVIRONMENT === 'dev'

  switch (mainPath) {
    case 'orders':
      return [
        {
          route: appRoutes.subscriptionOrders,
          content: <SubscriptionOrdersLinkContent />,
        },
        {
          route: appRoutes.deviceOrders,
          content: <DeviceOrdersLinkContent />,
        },
        hasShop && {
          route: appRoutes.ordersShop,
          content: <ShopOrdersLinkContent />,
        },
        {
          route: appRoutes.devicePolicyPrices,
          content: <Translation id="Device Prices" />,
        },
        // TODO: enable for production
        isDevelopmentMode && {
          route: appRoutes.ordersProducts,
          content: <Translation id="Products" />,
        },
      ].filter(link => !!link)
    default:
      return []
  }
}

const MAIN_PATH_ALIAS = {
  example: 'orders',
}

const SubNavigation = () => {
  const { pathname } = useLocation()
  const { whiteLabel } = useAppContext()
  const mainPath = getMainPath(pathname)

  const [visible, setVisible] = useState(false)
  const [links, setLinks] = useState([])

  const subLinks = useSubLinks(mainPath)
  const userName = useProfile()?.username

  useEffect(() => {
    setVisible(subLinks.length > 0)
    // @ts-ignore
    subLinks.length > 0 && setLinks(subLinks)
  }, [mainPath, userName])

  return (
    <nav className={`sub-navigation ${visible ? 'is-visible' : 'is-hidden'} wl-${whiteLabel}`}>
      <ul>
        {links.map(({ route, content }, idx) => (
          <li key={idx}>
            <Link to={route}>{content}</Link>
          </li>
        ))}
      </ul>
    </nav>
  )
}
// @ts-ignore
const getMainPath = pathname => {
  const mainPath = pathname.split('/')[1]
  // @ts-ignore
  const alias = MAIN_PATH_ALIAS[mainPath]

  return alias || mainPath
}

export default SubNavigation
